export const INTRO_TEXT = "Discover where you fall on the introvert-extrovert spectrum.";
export const INTRO_BUTTON_TEXT = "Get Started!";


export const SUBMIT_TEXT = "Ready to find if you are an introvert or an extrovert?";
export const SUBMIT_BUTTON_TEXT = "Let's Go!";

export const RESULTS_RUOTE = "/questionnaire-ui/results";
export const HOME_RUOTE = "/questionnaire-ui";

export const SUBMIT_ERROR_TEXT = "You have not answered all the questions, please scroll up and answer them all to get your results."